import antdData from 'antd/lib/locale-provider/de_DE'
import localeData from 'react-intl/locale-data/de'

const messages = {
  /* ----------- Start Delete TracemarkID Popup ------------- */

  'deleteTracemarkID.link': 'Reset ownership to delete my Tracemark ID',
  'deleteTracemarkID.modal.header': 'Reset Tracemark ID',

  'deleteTracemarkID.step1.password': 'Insert your password',
  'deleteTracemarkID.step1.button': 'Validate',
  'deleteTracemarkID.step1.forgotPasswordLink': 'I forgot my password',

  'deleteTracemarkID.step2.resetText':
    'Please type the word RESET to confirm resetting your Tracemark ID and to allow for the ownership of this piece to be changed or for the piece to be returned.',

  'deleteTracemarkID.step3.success':
    'Thank you. The ownership and Tracemark ID for this piece have been reset.',

  /* ----------- End Delete TracemarkID Popup ------------- */

  /* ----------- Start Dynamic Panel Digital pass ------------- */
  'dynamicPanelsDigitalPass.header': 'Erhalten Sie Ihren Tracemark Passport',
  'dynamicPanelsDigitalPass.generateTracemarkIDButton': 'Erhalten Sie Ihren Tracemark Passport',

  'dynamicPanelsDigitalPass.uniqueCode':
    'Geben Sie den alphanumerischen Code ein, der auf Ihrem Tracemark-Etikett angezeigt wird',

  'dynamicPanelsDigitalPass.email': 'E-Mail',
  'dynamicPanelsDigitalPass.email2': 'E-Mail',
  'dynamicPanelsDigitalPass.firstName': 'Name',
  'dynamicPanelsDigitalPass.lastName': 'Nachname',
  'dynamicPanelsDigitalPass.password': 'Passwort',

  'dynamicPanelsDigitalPass.notificationHeader': 'Ihre Tracemark-ID wird heruntergeladen',
  'dynamicPanelsDigitalPass.notificationText':
    'Wir haben es Ihnen auch an die angegebene E-Mail-Adresse gesendet. Öffnen Sie die beigefügte Tracemark-ID auf Ihrem Smartphone, um sie in Ihrer digitalen Geldbörse zu speichern.',

  'dynamicPanelsDigitalPass.termsAndCondition1': 'Ich habe die',
  'dynamicPanelsDigitalPass.termsAndCondition2': ' Datenschutzrichtlinie ',
  'dynamicPanelsDigitalPass.termsAndCondition3':
    "von 'TRACEABLE LUXURY SERVICES, S.L.' gelesen und akzeptiere ausdrücklich die Bedingungen für die Verarbeitung meiner personenbezogenen Daten.",

  'dynamicPanelsDigitalPass.resetOwnership':
    'Zurücksetzen der Eigentümerschaft des Tracemark Passports',
  'dynamicPanelsDigitalPass.password.text':
    'Bitte geben Sie Ihr Passwort ein, um Ihren Tracemark Passport',
  'dynamicPanelsDigitalPass.forgotPassword': 'Passwort vergessen?',

  'dynamicPanelsDigitalPass.step1': 'Authentifizieren Sie Ihr Stück',
  'dynamicPanelsDigitalPass.step2': 'Erstellen Sie einen Tracemark-Pass',
  'dynamicPanelsDigitalPass.Authenticate': 'Authentifizieren',
  'dynamicPanelsDigitalPass.personalDetails': 'Persönliche Daten',
  'dynamicPanelsDigitalPass.password.text1': 'Legen Sie ein Passwort fest',
  'dynamicPanelsDigitalPass.password.text2':
    'Bitte legen Sie ein Passwort fest, um Ihr Eigentum an diesem Schmuckstück zu registrieren und Ihren Tracemark Passport zu sichern:',
  'dynamicPanelsDigitalPass.confirmPassword': 'Passwort bestätigen',

  'dynamicPanelsDigitalPass.required.uniqueCode': 'Bitte geben Sie einen eindeutigen Code ein',
  'dynamicPanelsDigitalPass.required.name': 'Bitte geben Sie den Vornamen ein',
  'dynamicPanelsDigitalPass.required.lastName': 'Bitte geben Sie den Nachnamen ein',
  'dynamicPanelsDigitalPass.required.email': 'Bitte geben Sie Ihre E-Mail-Adresse ein',
  'dynamicPanelsDigitalPass.required.validEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'dynamicPanelsDigitalPass.required.terms':
    'Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen',
  'dynamicPanelsDigitalPass.required.password': 'Bitte geben Sie das Passwort ein',
  'dynamicPanelsDigitalPass.required.confirmPassword':
    'Bitte geben Sie das Bestätigungspasswort ein',
  'dynamicPanelsDigitalPass.required.matchPassword':
    'Ihr neues Passwort und Ihr Bestätigungspasswort stimmen nicht überein',
  /* ----------- End  Dynamic Panel Digital pass ------------- */
}

export default {
  locale: 'de-DE',
  antdData,
  localeData,
  messages,
}
